import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * URL search param에 대한 optimistic update를 제공하는 훅.
 * 값 변경 시 즉시 반영하고, URL 동기화가 완료되면 optimistic 상태를 해제한다.
 */
export function useOptimisticSearchParam(key: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlValue = searchParams.get(key);
  const [optimistic, setOptimistic] = useState<string | null>(null);

  // URL이 따라잡으면 optimistic 해제
  useEffect(() => {
    setOptimistic(null);
  }, [urlValue]);

  const value = optimistic ?? urlValue;

  const setValue = useCallback(
    (newValue: string) => {
      setOptimistic(newValue);
      setSearchParams({ [key]: newValue });
    },
    [key, setSearchParams],
  );

  return [value, setValue] as const;
}
